import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import './UserProfile.css';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../redux/AuthReducer/action';

/**
 * UserProfileDropdown
 * 
 * @param {boolean} sidebarExpanded - when true (sidebar is expanded), show name + email next to avatar
 * @param {function} onToggle - callback when dropdown is toggled open/closed
 */
const UserProfileDropdown = ({ sidebarExpanded, onToggle }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [show, setShow] = useState(false);

    const isPopupDisabled = sidebarExpanded === false;

    // Automatically close the dropdown if sidebar collapses
    useEffect(() => {
        if (isPopupDisabled && show) {
            setShow(false);
            if (onToggle) onToggle(false);
        }
    }, [isPopupDisabled, show, onToggle]);

    const handleToggle = (nextShow) => {
        if (isPopupDisabled) {
            setShow(false);
            if (onToggle) onToggle(false);
            return;
        }
        setShow(nextShow);
        if (onToggle) onToggle(nextShow);
    };

    let officer = JSON.parse(sessionStorage.getItem("officer")) || {};
    let initials = "";
    if (officer?.first_name) initials += officer.first_name.charAt(0).toUpperCase();
    if (officer?.last_name)  initials += officer.last_name.charAt(0).toUpperCase();
    if (!initials) initials = "U";

    return (
        <Dropdown
            align="end"
            drop="up"
            show={show}
            onToggle={handleToggle}
            className="userProfileContainer position-relative"
        >
            <Dropdown.Toggle
                variant="light"
                id="dropdown-user"
                className={`userProfileToggle d-flex align-items-center border-0 bg-transparent ${isPopupDisabled ? 'pe-none' : ''}`}
                style={{ cursor: isPopupDisabled ? 'default' : 'pointer' }}
            >
                <div className="userProfileAvatar">
                    {initials}
                </div>
                {sidebarExpanded && (
                    <div className="userProfileInfo ms-2 text-start">
                        <div className="userProfileName fw-bold">
                            {`${officer?.first_name || 'User'} ${officer?.last_name || ''}`}
                        </div>
                        <div className="userProfileRole text-muted small">
                            {officer?.email || 'Admin'}
                        </div>
                    </div>
                )}
            </Dropdown.Toggle>

            {!isPopupDisabled && (
                <Dropdown.Menu
                    className="shadow-lg border-0 p-3"
                    style={{ minWidth: '260px', borderRadius: '12px', marginBottom: '8px', zIndex: 1100 }}
                >
                    <div className="d-flex align-items-center mb-3 p-2 bg-light rounded">
                        <div className="userProfileAvatar large">
                            {initials}
                        </div>
                        <div className="ms-3">
                            <div className="fw-bold">{`${officer?.first_name || ''} ${officer?.last_name || ''}`}</div>
                            <div className="text-muted small">{officer?.email || ''}</div>
                        </div>
                    </div>
                    <Dropdown.Divider className="my-2" />
                    <Dropdown.Item
                        as="button"
                        className="btn w-100 mt-2 text-center fw-semibold logoutBtn"
                        style={{
                            borderRadius: "8px",
                            padding: "10px",
                            color: "#dc3545",
                            backgroundColor: "#fff",
                            border: "1px solid #dc3545"
                        }}
                        onClick={() => {
                            let success = dispatch(logout);
                            if (success) navigate("/");
                        }}
                    >
                        Log Out
                    </Dropdown.Item>
                </Dropdown.Menu>
            )}
        </Dropdown>
    );
};

export default UserProfileDropdown;